import {useRouter} from 'next/router';
import type {FC} from 'react';
import {LOGIN, PROFILE_AC_EMAIL} from '../../../../../config/constants/routes';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../../../../core/entities/login/constants';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {useIsAppWebView} from '../../../../../shared/hooks/useIsAppWebView';
import {getMailAuthLinkWithParamsHooks} from '../../../../../shared/services/getMailAuthLinkWithParamsHooks';

type Props = {
  registerText?: string;
  loginText?: string;
  isStudentVerificationRequired?: boolean;
};

export const AuthActionButtons: FC<Props> = ({
  registerText = '会員登録',
  loginText = 'ログイン',
  isStudentVerificationRequired = false,
}) => {
  const isWebView = useIsAppWebView();
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  const handleRegisterClick = () => {
    location.href = mailAuthLink;
  };

  const handleLoginClick = async () => {
    const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
    if (isWebView) {
      location.href = path;
    } else {
      await router.push(path);
    }
  };

  if (isStudentVerificationRequired) {
    return (
      <CommonLink
        href={PROFILE_AC_EMAIL}
        className="bg-gradient-to-r from-gradient-register-l to-gradient-register-r rounded-full px-16 py-8 text-base font-bold text-white cursor-pointer hover:opacity-60"
      >
        大学認証を完了する
      </CommonLink>
    );
  }

  return (
    <div className="flex gap-12">
      <button
        type="button"
        className="bg-gradient-to-r from-gradient-register-l to-gradient-register-r rounded-full px-16 py-8 text-base font-bold text-white cursor-pointer hover:opacity-60"
        onClick={handleRegisterClick}
      >
        {registerText}
      </button>
      <button
        type="button"
        className="bg-white outline outline-2 outline-primary rounded-full px-16 py-8 text-base font-bold text-primary cursor-pointer hover:opacity-60"
        onClick={handleLoginClick}
      >
        {loginText}
      </button>
    </div>
  );
};
